import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfirmareDocumenteService {
    private token!: string;
    private httpOptions: any;
    private basePath = environment.interop.basePath;
    private getUsersUrl = this.basePath + environment.interop.platform.nomenclatoare.citizen.searchCitizen;
    private getCnpUrl = this.basePath + environment.interop.platform.nomenclatoare.citizen.searchCnp;
    public fileDownloadUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.fileDownload;
    public smsEmailDownloadUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.smsEmailDownload;

    constructor(private http: HttpClient) { }

    getUsers(user: string) {
        return this.http.post(this.getUsersUrl, { search: user });
    }

    getCnp(cnp: string) {
        return this.http.post(this.getCnpUrl, { search: cnp });
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
